import SingleFamilyContractDetails from 'app/shared/model/SingleFamilyContractDetails';

const SingleFamilyContract = ({
    isRequired = false,
    isActive = false,
    details = {},
} = {}) => ({
    isRequired: Boolean(isRequired),
    isActive: Boolean(isActive),
    details: SingleFamilyContractDetails(details),
});

export default SingleFamilyContract;
